export const getCurrentPageSize = (carousel) =>
  parseInt(
    carousel
      .querySelector(".carousel__content__wrapper")
      .classList.value.match(/\d/g)
      .join()
  );
